package org.multiplatform.kotfolio.pages.compose

import androidx.compose.runtime.*
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText

import org.jetbrains.compose.web.css.*

@Page("/compose/adaptive_layout")
@Composable
fun AdaptiveLayoutComposePage() {
    BlogLayout(
        PageProperties(
            "Adaptive Layout",
        ),
        BlogProperties("Jetpack Compose", "Adaptive Layout")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Adaptive Layout",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/xephosbot/AnilibriaRefresh
            KotlinCode(
                code = """
                    --- ThreePaneScaffold.kt ---
                    @ExperimentalMaterial3AdaptiveApi
                    @Composable
                    fun <T> NavigableListDetailPaneScaffold(
                        navigator: ThreePaneScaffoldNavigator<T>,
                        listPane: @Composable ThreePaneScaffoldPaneScope.() -> Unit,
                        detailPane: @Composable ThreePaneScaffoldPaneScope.() -> Unit,
                        modifier: Modifier = Modifier,
                        extraPane: (@Composable ThreePaneScaffoldPaneScope.() -> Unit)? = null,
                        defaultBackBehavior: BackNavigationBehavior =
                            BackNavigationBehavior.PopUntilScaffoldValueChange,
                        paneExpansionDragHandle: (@Composable ThreePaneScaffoldScope.(PaneExpansionState) -> Unit)? =
                            null,
                        paneExpansionState: PaneExpansionState? = null,
                    ) {
                        ThreePaneScaffoldPredictiveBackHandler(
                            navigator = navigator,
                            backBehavior = defaultBackBehavior,
                        )

                        ListDetailPaneScaffold(
                            modifier = modifier,
                            directive = navigator.scaffoldDirective,
                            value = navigator.scaffoldValue,
                            detailPane = detailPane,
                            listPane = listPane,
                            extraPane = extraPane,
                            paneExpansionDragHandle = paneExpansionDragHandle,
                            paneExpansionState = paneExpansionState,
                        )
                    }
                    
                    @OptIn(ExperimentalMaterial3AdaptiveApi::class)
                        fun ThreePaneScaffoldNavigator<*>.isExpanded(role: ThreePaneScaffoldRole) =
                            scaffoldValue[role] == PaneAdaptedValue.Expanded
                    
                    @OptIn(ExperimentalMaterial3AdaptiveApi::class)
                        fun ThreePaneScaffoldNavigator<*>.isHidden(role: ThreePaneScaffoldRole) =
                            scaffoldValue[role] == PaneAdaptedValue.Hidden
                    
                    @OptIn(ExperimentalMaterial3Api::class, ExperimentalMaterial3AdaptiveApi::class)
                    @Composable
                    private fun ProfileScreenContent(
                        modifier: Modifier = Modifier,
                        state: ProfileScreenState,
                        onAction: (ProfileScreenAction) -> Unit,
                        onReleaseClick: (Int) -> Unit,
                    ) {
                        val scaffoldNavigator = rememberListDetailPaneScaffoldNavigator<PreferenceItem>()
                        val scope = rememberCoroutineScope()
                        val isTwoPaneLayout = scaffoldNavigator.isExpanded(ListDetailPaneScaffoldRole.List) && scaffoldNavigator.isExpanded(ListDetailPaneScaffoldRole.Detail)
                        val backBehavior = if (isTwoPaneLayout) { BackNavigationBehavior.PopUntilContentChange
                        } else {
                            BackNavigationBehavior.PopUntilScaffoldValueChange
                        }

                        val selectedItem = scaffoldNavigator.currentDestination?.contentKey

                        NavigableListDetailPaneScaffold(
                            navigator = scaffoldNavigator,
                            defaultBackBehavior = backBehavior,
                            listPane = {
                                
                            },
                            detailPane = {
                                
                            },
                            paneExpansionState = rememberPaneExpansionState(
                                keyProvider = scaffoldNavigator.scaffoldValue,
                                anchors = PaneExpansionAnchors
                            ),
                            paneExpansionDragHandle = { state ->
                                val interactionSource = remember { MutableInteractionSource() }
                                VerticalDragHandle(
                                    modifier = Modifier.paneExpansionDraggable(
                                        state = state,
                                        minTouchTargetSize = LocalMinimumInteractiveComponentSize.current,
                                        interactionSource = interactionSource,
                                        semanticsProperties = state.defaultDragHandleSemantics()
                                    ),
                                    interactionSource = interactionSource
                                )
                            }
                        )
                    }
                    
                    @OptIn(ExperimentalMaterial3AdaptiveApi::class)
                    private val PaneExpansionAnchors =
                        listOf(
                            PaneExpansionAnchor.Proportion(0f),
                            PaneExpansionAnchor.Offset.fromStart(360.dp),
                            PaneExpansionAnchor.Proportion(0.5f),
                            PaneExpansionAnchor.Offset.fromEnd(360.dp),
                        )
                    """.trimIndent()
            )
        }
    }
}

//https://github.com/isaruff/ComposePlayground
//https://github.com/xephosbot/AnilibriaRefresh
//https://github.com/tbahlai/AdaptiveLayoutNav3
//https://github.com/gamerlogue/app.git
////https://github.com/Hussienfahmy/GPA_Manager.git (LazyColumn Swap Item Animation (MoveUp - MoveDown Item, Firebase Notification (Good), Platform Navigation)